import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { RevealHeading, Reveal } from "@/components/Reveal";
import { Plus, Minus } from "lucide-react";

export default function Faq() {
  const [faqs, setFaqs] = useState([]);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-void min-h-screen" data-testid="faq-page">
      <Navbar />
      <section className="pt-32 md:pt-44 pb-16 md:pb-24 border-b border-[#222]">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-neon mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-neon" /> Questions Answered
          </div>
          <h1 className="font-display uppercase text-6xl md:text-8xl lg:text-[10vw] leading-[0.82] tracking-tight">
            <RevealHeading lines={["FAQ"]} />
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-[1100px] px-5 md:px-10 py-16 md:py-24">
        {faqs.length === 0 ? (
          <div className="font-mono text-[#9CA3AF]">No FAQs yet.</div>
        ) : (
          <div className="border-t border-[#222]">
            {faqs.map((f, i) => {
              const isOpen = openId === f.id;
              return (
                <Reveal key={f.id} delay={i * 0.04}>
                  <div className="border-b border-[#222]">
                    <button
                      data-testid={`faq-item-${f.id}`}
                      onClick={() => setOpenId(isOpen ? null : f.id)}
                      className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                    >
                      <span className="font-grotesk font-bold text-xl md:text-2xl text-[#FAFAFA] group-hover:text-neon transition-colors">{f.question}</span>
                      <span className="shrink-0 text-neon">{isOpen ? <Minus /> : <Plus />}</span>
                    </button>
                    {isOpen && <p className="pb-7 font-mono text-sm md:text-base text-[#9CA3AF] leading-relaxed max-w-3xl">{f.answer}</p>}
                  </div>
                </Reveal>
              );
            })}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
